<template>
  <div>
    <b-loading :is-full-page="true" :active="loading"></b-loading>
    <div class="container" v-if="!loading">
      <div class="section">
        <div class="columns is-vcentered">
          <div class="column is-2 is-offset-2">
            <img :src="`${event.imgUrl}`" style="width: 150px" />
          </div>
          <div class="column is-6">
            <h1 class="title">{{ event.eventname }}</h1>
          </div>
        </div>
      </div>
      <div class="columns is-vcentered">
        <div class="column is-8 is-offset-2">
          <div class="flex-card light-bordered light-raised">
            <div class="card-body">
              <div class="has-text-centered has-margin-bottom-30">
                <h2 class="title">Join a Team</h2>
              </div>
              <ValidationObserver v-slot="{ passes }">
                <form @submit.prevent="passes(submit)">
                  <div class="columns is-multiline">
                    <div class="column is-6-desktop">
                      <div class="control">
                        <ValidationProvider
                          name="Search option"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <b-field
                            label="Search"
                            :type="{ 'is-danger': errors.length > 0 }"
                            :message="errors[0]"
                          >
                            <b-select
                              v-model="search.by"
                              placeholder="Find your team by"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <option value="teamname">Team Name</option>
                              <option value="captain">
                                Captain Email Address
                              </option>
                            </b-select>
                          </b-field>
                        </ValidationProvider>
                      </div>
                    </div>
                    <div class="column is-6-desktop">
                      <div class="control">
                        <ValidationProvider
                          name="Search Value"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <b-field
                            :label="
                              search.by === 'teamname'
                                ? 'Enter Exact Team Name'
                                : 'Enter the Team Captains Email Address'
                            "
                            :type="{ 'is-danger': errors.length > 0 }"
                            :message="errors[0]"
                          >
                            <b-input v-model="search.keyword" />
                          </b-field>
                        </ValidationProvider>
                      </div>
                    </div>
                  </div>
                  <div class="has-text-centered">
                    <div class="is-block has-text-centered">
                      <button
                        class="button btn-align no-lh raised is-medium primary-btn"
                        type="submit"
                        :disabled="saving"
                        :class="{ 'is-loading': saving }"
                      >
                        Find Your Team
                      </button>
                    </div>
                  </div>
                </form>
              </ValidationObserver>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import EventEntryApi from "@/api/event-entry";
import TeamMemberApi from "@/api/team-member";
export default {
  data() {
    return {
      loading: true,
      search: {
        by: "teamname",
      },
      saving: false,
    };
  },
  computed: {
    ...mapGetters(["user", "event"]),
  },
  async created() {
    this.getEvent(this.$route.params.id).then(() => {
      this.loading = false;
    });
  },
  methods: {
    ...mapActions(["getEvent"]),
    async submit() {
      this.saving = true;
      try {
        this.saving = false;
        let searchresult = null;
        if (this.search.by === "teamname") {
          searchresult = await EventEntryApi.findByTeamName(
            this.event._id,
            this.search.keyword
          );
          if (searchresult === null) {
            this.$buefy.toast.open({
              message:
                "Cannot find team, remember to enter the exact name. Character casing is ignored.",
              position: "is-top",
              type: "is-danger",
            });
            this.saving = false;
            return;
          }
        } else {
          searchresult = await EventEntryApi.findByTeamCaptain(
            this.event._id,
            this.search.keyword
          );
          if (searchresult === "") {
            this.$buefy.toast.open({
              message:
                "Cannot find team, remember to enter the exact email address. Character casing is ignored.",
              position: "is-top",
              type: "is-danger",
            });
            this.saving = false;
            return;
          }
        }

        let members = await TeamMemberApi.membersForEntry(searchresult._id);
        let partOfTeam = members.find(
          (member) => member.user && member.user._id === this.user._id
        );
        if (partOfTeam) {
          this.$buefy.toast.open({
            message: "You are already part of the team.",
            position: "is-top",
            type: "is-danger",
          });
          this.saving = false;
          return;
        }

        this.$buefy.toast.open({
          message: "We found your team, please complete the following form.",
          position: "is-top",
          type: "is-success",
        });
        this.$router.push({
          name: "JoinATeamStep2",
          params: { id: searchresult._id },
        });
      } catch (error) {
        console.log(error);
        this.saving = false;
        this.$buefy.toast.open({
          message: "Error finding your team",
          position: "is-top",
          type: "is-danger",
        });
      }
    },
  },
};
</script>
